module.exports = __webpack_public_path__ + "img/img_left_nav_realtime_hover.e6cdb0c8.svg";